import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { get, size } from "lodash";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Stack,
  Divider,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import { useSnackbar } from "notistack";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import Iconify from "../../components/iconify/iconify";
import CustomPopover from "../../components/custom-popover/custom-popover";
import usePopover from "../../components/custom-popover/use-popover";
import { Box } from "@mui/system";
import { color } from "../../utils/constant";
import { useConsultForm } from "../../data/talons/Consult/useConsultForm";
import { useDispatch, useSelector } from "react-redux";
import { getConsultData } from "../../data/selectors/Consult/consultForm.selector";

export default function ConsultForm(props) {
  const { enqueueSnackbar } = useSnackbar();
  // const { editId } = props;
  const editItem = useSelector(getConsultData);

  const defaultValues = useMemo(() => ({
    name: get(editItem, "consult_name", ""),
  }));

  const {
    status,
    consultEntrySchema,
    handleStatusComboChange,
    consultEntry,
    consultUpdate,
    handleFileChange,
    getConsultbyId,
  } = useConsultForm({
    existingStatus: get(editItem, "status", 0),
    existingImageUrl: { url: get(editItem, "image_url", "") },
  });

  const popover = usePopover();

  const [imageData, setImageData] = useState(
    size(editItem?.image_url) === 0 ? null : editItem.image_url
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
  } = useForm({
    resolver: joiResolver(consultEntrySchema),
    defaultValues,
  });

  const onUserSubmit = useCallback(async () => {
    try {
      const res =
        get(editItem, "id", null) === null
          ? await consultEntry({
              ...getValues(),
            })
          : await consultUpdate({
              ...getValues(),
              id: get(editItem, "id", null),
            });
      if (res === true) {
        props.postSubmit();
      } else {
        enqueueSnackbar("Problem While Saving Consult Data", {
          variant: "error",
        });
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [consultEntry, consultUpdate]);

  const fileUpload = (file) => {
    handleFileChange(file);
    popover.onClose();
    const reader = new FileReader();

    reader.onload = () => {
      setImageData(reader.result);
    };

    reader.readAsDataURL(file);
  };
  const onlyCharacters = (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z ]*$/, "");

    return e.target.value;
  };
  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Speciality Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="name"
            name="name"
            label="Speciality"
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            onInput={(e) => onlyCharacters(e)}
            {...register("name")}
            autoComplete="false"
            error={size(errors?.name?.message) > 0 ? true : false}
            helperText={
              size(errors?.name?.message) > 0 ? errors?.name?.message : ""
            }
          />
          <Typography mt={1}>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: color.button,
                    },
                  }}
                  id="is_labour"
                  checked={status}
                  onChange={handleStatusComboChange}
                />
              }
              label="Active"
            />
          </Typography>
        </Grid>

        {/* <Grid item xs={12} sm={12}>
          <TextField type="file" hidden={true}>
            <ImageIcon />
          </TextField>
        </Grid> */}
        {imageData === null ? (
          <Grid item xs={12} sm={6}>
            <IconButton
              className="p-0"
              style={{ width: "100%", borderRadius: "0px", padding: 0 }}
              color="primary"
            >
              <label
                htmlFor="upload"
                onMouseEnter={(e) => (e.target.style.padding = "1rem")}
                style={{
                  width: "100%",
                  height: "210px",
                  border: "2px dashed #1976d2",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <>
                  <AddAPhotoIcon style={{ fontSize: "3rem" }} />
                  <input
                    accept="image/*"
                    onChange={(e) => fileUpload(e.target.files[0])}
                    type="file"
                    hidden={true}
                    id="upload"
                  />
                </>
              </label>
            </IconButton>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ width: "100%", textAlign: "center", height: "210px" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <IconButton
                className="iconbtn"
                onClick={popover.onOpen}
                sx={{
                  color: "blue",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 255, 0.1)", // on hover background
                  },
                }}
              >
                <Iconify icon="eva:more-vertical-fill" />
              </IconButton>
            </Box>
            <img
              className="uploadedImg"
              src={imageData}
              style={{
                marginBottom: "10px",
                width: "100%",
                height: "95%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "-35px",
              }}
            />

            <CustomPopover
              open={popover.open}
              onClose={popover.onClose}
              arrow="right-top"
              sx={{ width: 100, ml: 1, marginTop: "30px" }}
            >
              <IconButton
                style={{
                  width: "100%",
                  borderRadius: "0px",
                  fontSize: "16px",
                  fontWeight: "normal",
                }}
                color="primary"
                sx={{ padding: 0 }}
              >
                <label
                  htmlFor="uploadagain"
                  style={{
                    width: "100%",
                    padding: 7,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Iconify icon="solar:pen-bold" />
                    <span style={{ marginLeft: "10px" }}>Edit</span>
                    <input
                      className="uploadInput"
                      accept="image/*"
                      onChange={(e) => fileUpload(e.target.files[0])}
                      // onClick={(e) => editedFileUpload(e.target)}
                      type="file"
                      hidden={true}
                      id="uploadagain"
                    />
                  </div>
                </label>
              </IconButton>
              <div
                onClick={() => setImageData(null)}
                style={{
                  display: "flex",
                  marginLeft: "5px",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "red",
                }}
              >
                {/* <Iconify icon="solar:trash-bin-trash-bold" />
                <span style={{ marginLeft: "10px" }}>Delete</span> */}
              </div>
            </CustomPopover>
          </Grid>
        )}

        <Grid container direction="row" mt={4}>
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onUserSubmit)();
                }}
              >
                Save
              </Button>
              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  props.postSubmit();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
